<template>
  <main class="evalFigma w-full finalEvaluationPg">
    <EvalShell title="Finalize Evaluation" subTitle="Confirm the last few options before the quote is generated."
      :step="4" :show-details="false" :show-unit="false" :job-id="$route.params.id" :unit-id="$route.query.unit_id">
      <!-- Figma E1 (5657:1309) -->


      <div v-if="isApiCalled"
        class="finalEvalSec flex flex-wrap justify-center gap-[20px] largeDesktop:gap-[34px] mt-[10px]">
        <template v-for="(item, index) in preChecksDetail" :key="index">
          <div v-if="item.identifier == 'is_diagnosis_fee_applicable'"
            class="w-full tablet:w-[calc(50%-10px)] desktop:w-[calc(25%-15px)] largeDesktop:w-[calc(25%-30px)] flex flex-col items-center justify-between gap-[16px] laptop:min-h-[465px] px-[10px] largeDesktop:px-[22px] py-[30px] rounded-[14px] border-1 border-[#E9ECF1] bg-white shadow-[0px_2px_10px_0px_#1217240D] text-center font-roboto">
         
              <span class="w-[90px] h-[90px] rounded-full flex items-center justify-center bg-[#7695FF] flex-shrink-0">
                <img src="../../assets/images/apply-eval-icon.png" alt=""
                  class="w-[50px] h-[50px] object-contain brightness-0 invert">
              </span>
              <h5
                class="m-0 text-[15px] largeDesktop:text-[16px] leading-[25px] font-semibold text-[#1B4DB8] mt-[16px]">
                {{ item.title }}</h5>
              <p class="m-0 mt-[8px] text-[13px] largeDesktop:text-[14px] leading-[20px] text-[#5B616B]">{{
                item.description }}</p>
            <div
              class="w-full flex items-center justify-between gap-[20px] px-[15px] largeDesktop:px-[20px] py-[10px] largeDesktop:py-[14px] rounded-[8px] bg-[#A3AAD2] text-white">
              <span class="text-[15px] largeDesktop:text-[16px] font-medium">Evaluation Fees</span>
              <span class="text-[18px] largeDesktop:text-[20px] font-bold">{{ item.amount_text }}</span>
            </div>
            <p class="m-0 text-[15px] leading-[22px] text-[#2E3138] my-[20px]">Apply evaluation fees</p>
            <label :for="item.identifier"
              class="flex items-center justify-center gap-[10px] m-0 cursor-pointer select-none text-[14px] leading-[20px] text-[#2E3138]">
              No
              <input :id="item.identifier" v-model="storePreChecks[item.identifier]" type="checkbox" class="sr-only"
                :true-value="1" :false-value="0">
              <span class="relative w-[60px] h-[26px] rounded-full transition"
                :class="storePreChecks[item.identifier] == 1 ? 'bg-[#14C38E33]' : 'bg-[#E5E7EB]'">
                <span class="absolute top-0 w-[26px] h-[26px] rounded-full transition-all"
                  :class="storePreChecks[item.identifier] == 1 ? 'left-[34px] bg-[#14C38E]' : 'left-0 bg-[#9CA3AF]'" />
              </span>
              Yes
            </label>
          </div>
          <div v-else-if="item.identifier == 'special_part_timestamp'"
            class="w-full tablet:w-[calc(50%-10px)] desktop:w-[calc(25%-15px)] largeDesktop:w-[calc(25%-30px)] flex flex-col items-center justify-between gap-[16px] laptop:min-h-[465px] px-[10px] largeDesktop:px-[22px] py-[30px] rounded-[14px] border-1 border-[#E9ECF1] bg-white shadow-[0px_2px_10px_0px_#1217240D] text-center font-roboto">
              <span class="w-[90px] h-[90px] rounded-full flex items-center justify-center bg-[#7695FF] flex-shrink-0">
                <img src="../../assets/images/spcial-parts-icon.png" alt=""
                  class="w-[50px] h-[50px] object-contain brightness-0 invert">
              </span>
              <h5
                class="m-0 text-[15px] largeDesktop:text-[16px] leading-[25px] font-semibold text-[#1B4DB8] mt-[16px]">
                {{ item.title }}</h5>
              <p class="m-0 mt-[8px] text-[13px] largeDesktop:text-[14px] leading-[20px] text-[#5B616B]">{{
                item.description }}</p>
              <button type="button"
                class="h-[40px] largeDesktop:h-[50px] px-[30px] largeDesktop:px-[40px] rounded-[26px] border-[1.5px] border-[#A084E8] bg-[#fff] hover:bg-[#A084E8] text-[15px] largeDesktop:text-[16px] leading-[23px] font-medium text-[#A084E8] hover:text-[#fff] [@media(max-width:1023px)]:!bg-[#A084E8] [@media(max-width:1023px)]:!text-[#fff] transition-all duration-300"
                @click="viewSpecialParts()">
                View Parts
              </button>
              <p class="m-0 text-[15px] leading-[22px] text-[#E8536E]">Select Date</p>
              <!-- date input (48px, #DFE3EA) + #A3AAD2 calendar block like Figma -->
              <div class="finalDate w-full flex items-center gap-[10px] text-left">
                <date-picker v-model:value="storePreChecks['partDate']" v-model:open="partDateOpen"
                  input-class="disable-input" format="MM/DD/YYYY" placeholder="Select Date" type="date" :use12h="true"
                  :confirm="true" :readonly="false" :clearable="false" :default-value="new Date()"
                  :disabled-date="disabledBefore" :disabled-time="disabledBeforeTime" :editable="false"
                  value-type="format" @change="handleDateChange" />
                <div
                  class="min-w-[46px] min-h-[46px] rounded-[8px] flex justify-center items-center cursor-pointer bg-[#A3AAD2]"
                  @click="openPartDatePicker">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="#fff"
                      d="M17.75 3.935v-1.31a.75.75 0 1 0-1.5 0v1.25h-8.5v-1.25a.75.75 0 1 0-1.5 0v1.31a4.76 4.76 0 0 0-4 4.69v8.75A4.75 4.75 0 0 0 7 22.125h10a4.75 4.75 0 0 0 4.75-4.75v-8.75a4.76 4.76 0 0 0-4-4.69m-9.35 14h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m0-3.08h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m4.11 3.08h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m0-3.08h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m4.11 3.08h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m0-3.08h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m3.63-5H3.75v-1.25a3.24 3.24 0 0 1 2.5-3.15v1.15a.75.75 0 1 0 1.5 0v-1.25h8.5v1.25a.75.75 0 1 0 1.5 0v-1.15a3.24 3.24 0 0 1 2.5 3.15z" />
                  </svg>
                </div>
              </div>
          </div>
          <div v-else-if="item.identifier == 'is_create_child_booking'"
            class="w-full tablet:w-[calc(50%-10px)] desktop:w-[calc(25%-15px)] largeDesktop:w-[calc(25%-30px)] flex flex-col items-center justify-between gap-[16px] laptop:min-h-[465px] px-[10px] largeDesktop:px-[22px] py-[30px] rounded-[14px] border-1 border-[#E9ECF1] bg-white shadow-[0px_2px_10px_0px_#1217240D] text-center font-roboto evalCard">
              <span class="w-[90px] h-[90px] rounded-full flex items-center justify-center bg-[#7695FF] flex-shrink-0">
                <img src="../../assets/images/evaluate-big-icon.png" alt=""
                  class="w-[50px] h-[50px] object-contain brightness-0 invert">
              </span>
              <h5
                class="m-0 text-[15px] largeDesktop:text-[16px] leading-[25px] font-semibold text-[#1B4DB8] mt-[16px]">
                {{ item.title }}</h5>
              <p class="m-0 mt-[8px] text-[13px] largeDesktop:text-[14px] leading-[20px] text-[#5B616B]">{{
                item.description }}</p>
              <label :for="item.identifier"
                class="flex items-center justify-center gap-[10px] m-0 cursor-pointer select-none text-[14px] leading-[20px] text-[#2E3138]">
                No
                <input :id="item.identifier" v-model="storePreChecks[item.identifier]" type="checkbox" class="sr-only"
                  :true-value="1" :false-value="0" @click="onChildBookingClick(this)">
                <span class="relative w-[60px] h-[26px] rounded-full transition"
                  :class="storePreChecks[item.identifier] == 1 ? 'bg-[#14C38E33]' : 'bg-[#E5E7EB]'">
                  <span class="absolute top-0 w-[26px] h-[26px] rounded-full transition-all"
                    :class="storePreChecks[item.identifier] == 1 ? 'left-[34px] bg-[#14C38E]' : 'left-0 bg-[#9CA3AF]'" />
                </span>
                Yes
              </label>
              <div class="flex flex-col items-start gap-[10px] w-full">
                <label v-for="(opt, i) in item.services" :key="i" :for="item.identifier + '-' + i"
                  class="flex items-center gap-[10px] m-0 cursor-pointer text-[14px] leading-[17px] text-[#000000]">
                  <input :id="item.identifier + '-' + i" v-model="storePreChecks['child_booking_service_type']"
                    type="radio" class="sr-only" :name="item.identifier + '-radio'" :value="opt.id">
                  <span class="w-[24px] h-[24px] rounded-full flex items-center justify-center"
                    :class="storePreChecks['child_booking_service_type'] == opt.id ? 'bg-[#7695FF]' : 'bg-[#7695FF] border-[1.5px] border-[#7695FF]'">
                    <span v-if="storePreChecks['child_booking_service_type'] == opt.id"
                      class="w-[8px] h-[8px] rounded-full bg-white" />
                  </span>
                  {{ opt.title }}
                </label>
              </div>
          </div>
          <div v-else-if="item.identifier == 'is_consume_agreement_frequency'"
            class="w-full tablet:w-[calc(50%-10px)] desktop:w-[calc(25%-15px)] largeDesktop:w-[calc(25%-30px)] flex flex-col items-center justify-between gap-[16px] laptop:min-h-[465px] px-[10px] largeDesktop:px-[22px] py-[30px] rounded-[14px] border-1 border-[#E9ECF1] bg-white shadow-[0px_2px_10px_0px_#1217240D] text-center font-roboto maintenanceAgreement">
              <span
                class="w-[90px] h-[90px] rounded-full flex items-center justify-center bg-[#7695FF] flex-shrink-0"><img
                  src="../../assets/images/maintenance-agreement-icon.png" alt=""
                  class="w-[50px] h-[50px] object-contain brightness-0 invert"></span>
              <h5
                class="m-0 text-[15px] largeDesktop:text-[16px] leading-[25px] font-semibold text-[#1B4DB8] mt-[16px]">
                {{ item.title }}</h5>
              <p class="m-0 mt-[8px] text-[13px] largeDesktop:text-[14px] leading-[20px] text-[#5B616B]">{{
                item.description }}</p>
              <div
                class="w-full flex items-center justify-between gap-[12px] px-[16px] py-[11px] rounded-[8px] border-1 border-[#DFE3EA] text-[14px] leading-[20px]">
                <span class="text-[#5B616B]">Package</span>
                <span class="font-medium text-[#E8536E]">{{ item.agreement?.agreement_name }}</span>
              </div>
              <div
                class="w-full flex items-center justify-between gap-[12px] px-[16px] py-[11px] rounded-[8px] border-1 border-[#DFE3EA] text-[14px] leading-[20px]">
                <span class="text-[#5B616B]">Remaining Frequencies</span>
                <span class="font-medium text-[#2E3138]">{{ item.agreement?.remaining_visits }}</span>
              </div>
              <p class="m-0 mt-[4px] text-[15px] leading-[22px] text-[#2E3138]">Apply Agreement</p>
              <label :for="item.identifier"
                class="flex items-center justify-center gap-[10px] m-0 cursor-pointer select-none text-[14px] leading-[20px] text-[#2E3138]">
                No
                <input :id="item.identifier" v-model="storePreChecks[item.identifier]" type="checkbox" class="sr-only"
                  :true-value="1" :false-value="0">
                <span class="relative w-[60px] h-[26px] rounded-full transition"
                  :class="storePreChecks[item.identifier] == 1 ? 'bg-[#14C38E33]' : 'bg-[#E5E7EB]'">
                  <span class="absolute top-0 w-[26px] h-[26px] rounded-full transition-all"
                    :class="storePreChecks[item.identifier] == 1 ? 'left-[34px] bg-[#14C38E]' : 'left-0 bg-[#9CA3AF]'" />
                </span>
                Yes
              </label>
          </div>
        </template>
      </div>

      <!-- in the card on laptop; below laptop under the card (Figma mobile E1) -->
      <template #actions>
        <div class="absolute -bottom-[30px] left-0 right-0 laptop:relative laptop:bottom-0 flex flex-wrap justify-center items-center gap-[20px] mt-[30px] mobile:mb-[10px] laptop:mb-0">
          <EvalButton variant="back" @click="backButtonClicked()" />
          <EvalButton @click="nextButtonClicked()" />
        </div>
      </template>

      <!-- Figma "E2 · Special Parts (Modal)" -->
      <div id="viewSpecialPartsModal" ref="viewSpecialPartsModal" class="modal fade fxModal" tabindex="-1"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 420px">
          <div class="modal-content">
            <div class="modal-body p-[20px] font-roboto">
              <FxModalHeader title="Special Parts" />
              <p class="mb-[20px] mt-[30px] text-center text-[13px] text-[#666666]">
                List of Special Parts included in your diagnosis
              </p>
              <div class="flex flex-col px-[10px] gap-[10px] max-h-[50vh] overflow-y-auto">
                <div v-for="(item, index) in specialParts" :key="index"
                  class="px-[12px] py-[10px] rounded-[8px] border-1 border-[#EFEFEF] bg-white">
                  <p class="my-[6px] text-[14px] laptop:text-[16px] text-[#333333]">{{ item.part_name }}</p>
                  <div class="flex items-center justify-between text-[14px] laptop:text-[16px] laptop:flex flex-wrap gap-[20px] mt-[10px] mb-0">
                    <span class="text-[#7695FF]">Qty: <span class="text-[#333333]">{{ item.quantity }}</span></span>
                    <span class="text-[#7695FF]">Price: <span class="text-[#333333]">${{ $helper.formatAmount(item.cost_with_markup)
                        }}</span></span>
                  </div>
                </div>
                <p v-if="!specialParts || !specialParts.length"
                  class="m-0 py-[15px] text-center text-[13px] text-[#8A9099]">
                  No special parts</p>
              </div>
              <div class="flex justify-center mt-[20px] mb-[20px] laptop:mb-0">
                <button type="button" data-bs-dismiss="modal" aria-label="Close"
                  class="inline-flex items-center justify-center min-h-[34px] px-[26px] rounded-[5px] border-0 bg-[#F67280] text-[14px] font-medium text-white">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </EvalShell>
  </main>
</template>

<script>
import EvalShell from "@/components/nest_components/EvalShell.vue";
import EvalButton from "@/components/nest_components/EvalButton.vue";
import FxModalHeader from "@/components/nest_components/FxModalHeader.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import DatePicker from "vue-datepicker-next";
import { useToast } from "vue-toastification";
const toast = useToast();
import { Modal } from "bootstrap";

export default {
  components: {
    EvalShell,
    EvalButton,
    FxModalHeader,
    DatePicker,
  },

  computed: {
    ...mapGetters([
      "preChecksDetail",
      "preChecksStore",
      "specialParts",
      "storeChecksResponse",
      "getDiagnosisOptions",
    ]),
  },

  data() {
    return {
      jobId: this.$route.params.id,
      unit_id: this.$route.query.unit_id,
      modal: null,
      isApiCalled: false,
      storePreChecks: {
        is_diagnosis_fee_applicable: 0,
        child_booking_service_type: -1
      },
      partDateOpen: false,
    };
  },

  watch: {
    specialParts: function () {
      this.modal = new Modal(this.$refs.viewSpecialPartsModal);
      this.modal.show();
    },

    preChecksDetail: function () {

      if (this.preChecksDetail.length <= 0) {
        this.nextButtonClicked()
      }
      else {
        this.setValues();
        this.getDiagnosisOption({
          booking_id: this.jobId,
          diagnosis_type: "final_pre_checks",
        });
      }

    },

    getDiagnosisOptions: function () {
      this.setFinalPreChecks();
    },

    storeChecksResponse: function () {
      if (this.storePreChecks["partDate"] != null) {
        let data = moment(this.storePreChecks["partDate"]).unix();
        this.storePreChecks["special_part_timestamp"] = data;
      }
      if (this.preChecksDetail.length <= 0) {
        this.storePreChecks["is_diagnosis_fee_applicable"] = 0
      }

      this.storePreChecks["booking_id"] = this.jobId;
      this.storePreChecksDetails(this.storePreChecks);
    },

    preChecksStore: function () {
      this.$router.push({
        path: `/summary-detail/${this.$route.params.id}`,
        query: {
          unit_id: this.unit_id,
          is_from_mobile: this.$route.query.is_from_mobile,
        },
      });
    },
  },

  mounted() {
    this.getPreChecksDetails({
      booking_id: this.jobId,
    });
  },

  methods: {
    ...mapActions([
      "getPreChecksDetails",
      "getSpecialParts",
      "storePreChecksDetails",
      "storeChecks",
      "getDiagnosisOption",
    ]),
    openPartDatePicker() {
      this.partDateOpen = true;
    },

    disabledBefore: function (date) {
      const cdate = new Date();
      cdate.setHours(0, 0, 0, 0);
      return date < cdate;
    },

    disabledBeforeTime: function (date) {
      const cdate = new Date();
      return date < cdate;
    },

    setValues() {
      let self = this;
      this.preChecksDetail.forEach(function (obj) {
        self.storePreChecks[obj.identifier] = obj.default_value;
      });
    },

    backButtonClicked() {
      this.$router.go(-1);
    },

    onChildBookingClick(cb) {
      if (!cb.checked) {
        this.storePreChecks.child_booking_service_type = -1
      }
    },

    setFinalPreChecks() {
      let diagnosis_data = JSON.parse(
        this.getDiagnosisOptions?.[0]?.diagnosis_data || 'null' /* no saved diagnosis yet → null, not a crash */
      );

      for (let key in diagnosis_data) {
        this.storePreChecks[key] = diagnosis_data[key];
      }

      this.isApiCalled = true
    },

    nextButtonClicked() {
      if (this.isValid()) {
        this.storeChecks({
          booking_id: this.jobId,
          diagnosis_type: "final_pre_checks",
          diagnosis_data: JSON.stringify(this.storePreChecks),
        });
      }
    },

    isValid() {
      let status = true;
      if (
        this.storePreChecks["special_part_timestamp"] != undefined &&
        this.storePreChecks["special_part_timestamp"] == ""
      ) {
        status = false;
        toast.error("Special parts date and time required");
      } else if (
        this.storePreChecks["is_create_child_booking"] != undefined &&
        this.storePreChecks["is_create_child_booking"] == "1" && this.storePreChecks.child_booking_service_type == "-1"
      ) {
        status = false;
        toast.error("Please select another unit service type.");
      }

      return status;
    },

    viewSpecialParts() {
      this.getSpecialParts({
        booking_id: this.jobId,
      });
    },

    handleDateChange(newDate) {
      if (newDate) {
        let data = moment(newDate).unix();
        this.storePreChecks["special_part_timestamp"] = data;
      } else {
        this.unixTime = null;
      }
    },
  },
};
</script>
<style>
.finalEvaCard .buttonOrangeWhite {
  border-radius: 50px;
}

.specialPartsMainCard {
  height: 50vh;
  overflow-y: scroll;
}

.specialPartsMainCard::-webkit-scrollbar {
  width: 5px;
}

.specialPartsMainCard::-webkit-scrollbar-track {
  border-radius: 10px;
}

.specialPartsMainCard::-webkit-scrollbar-thumb {
  background: #fe5000;
  border-radius: 10px;
}

.maintenanceAgreement .packageCard {
  -webkit-box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 12px -6px rgba(0, 0, 0, 0.75);
}

.finalEvaCard .form-group [type="radio"]:checked+label:before,
.finalEvaCard .form-group [type="radio"]:not(:checked)+label:before {
  left: 4px;
  background: #092e87;
  top: -1px;
  border-color: #092e87;
}

.finalEvaCardMain p {
  font-size: 15px;
}

.finalEvaCardMain h5 {
  font-size: 18px;
}

.finalDate .mx-datepicker .mx-icon-calendar {
  display: none !important;
}

.finalDate .mx-input-wrapper input {
  display: block;
  width: 100%;
  padding: 22px 0.75rem;
  font-size: 15px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #2E3138 !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #DFE3EA !important;
  border-radius: 8px !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: 40px;
}
</style>
